import { useEffect, useRef } from "react";

import { markCustomerMessagesSeen } from "@/api/actions/message-share";

interface Props {
  token: string;
  seenUntil: string;
}

// 대화 목록 끝이 실제로 화면에 들어왔을 때 한 번만 읽음을 옮긴다 — 사진만 보고 나가면 읽지 않은 채로 남는다.
const MessageSeenMarker = ({ token, seenUntil }: Props) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el || typeof IntersectionObserver === "undefined") return;
    let sent = false;
    const observer = new IntersectionObserver((entries) => {
      if (sent || !entries.some((e) => e.isIntersecting)) return;
      sent = true;
      observer.disconnect();
      void markCustomerMessagesSeen({ token, seen_until: seenUntil });
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, [token, seenUntil]);

  return <div aria-hidden className="h-px" data-testid="customer-message-seen-marker" ref={ref} />;
};

export default MessageSeenMarker;
